import React from "react";
import { Message } from "semantic-ui-react";

const Verificado = (props) => {
  if (props.projeto.tem_certificado_inicial) {
    if (!props.projeto.projetoCertificado) {
      return <Message negative>Não enviado</Message>;
    }

    if (props.projeto.projetoCertificado?.verificado) {
      return <Message negative>Não verificado</Message>;
    }
    return <Message negative>Verificado</Message>;
  }

  return null;
};

export default Verificado;
